module.exports = __webpack_public_path__ + "6b34e6d57b3c911ad25b5c8789af8705.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/bloomberg-300.jpg
// module id = 1506
// module chunks = 0